/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Utils } from 'vmf';
import { Sv } from './Sv';

const { GlobalVar } = Utils;

class ServantGoodsCat extends Sv {
    constructor() {
        super();
        this.baseUrl += '/servantGoodsCat';
    }

    data({ pId, name, isAvailable, schoolOrgId } = {}) {
        return super.get('/data', {
            pId,
            name,
            isAvailable,
            schoolOrgId,
        });
    }

    getDetail({ id }) {
        return super.get('/get', { id }).then(json => {
            const { goodsCatImage } = json.data.data;
            if (!goodsCatImage) {
                json.data.data.goodsCatImage = [];
            } else {
                json.data.data.goodsCatImage = goodsCatImage.split(',').reduce((prev, curr) => {
                    prev.push({
                        name: curr,
                        address: GlobalVar.fileBasePath + curr,
                    });
                    return prev;
                }, []);
            }
            return json;
        });
    }

    save({ id, parentId, name, goodsCatImage, orderNum, isAvailable, schoolOrgId } = {}) {
        const goodsCatImageStr = goodsCatImage
            .reduce((prev, curr) => {
                prev.push(curr.name);
                return prev;
            }, [])
            .join(',');
        return super.post('/save', {
            id,
            parentId,
            name,
            goodsCatImage: goodsCatImageStr,
            orderNum,
            isAvailable,
            schoolOrgId,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    status({ id, isAvailable }) {
        return super.post('/status', {
            id,
            isAvailable,
        });
    }

    exists({ id, pId, name, schoolOrgId } = {}) {
        return super.get('/exists', {
            id,
            pId,
            name,
            schoolOrgId,
        });
    }

    select(schoolOrgId) {
        return super.get('/select', { schoolOrgId });
    }

    loadSelectNode({ id } = {}, config) {
        return super.get(
            '/loadSelectNode',
            {
                id,
            },
            {
                isRepeat: true,
                ...config,
            },
        );
    }
}

export default new ServantGoodsCat();
export { ServantGoodsCat };
